import { render, staticRenderFns } from "./DetalhePlanejamentoAlojamento.vue?vue&type=template&id=689e6772&"
import script from "./DetalhePlanejamentoAlojamento.vue?vue&type=script&lang=js&"
export * from "./DetalhePlanejamentoAlojamento.vue?vue&type=script&lang=js&"
import style0 from "./DetalhePlanejamentoAlojamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VFlex,VRow,VTab,VTabs})
